import { composer } from "../../../../../component-decorators/composer";
import { ModalNames } from "../../../../modals/modals";
import { TextButton } from "wix-style-react";
import React from "react";
import { CountriesPopover } from "./countries-popover";
export var OtherCountries = composer()
    .withMarketplaceStore()
    .withExperiments()
    .withTranslation()
    .compose(function (_a) {
    var popoverElementTitle = _a.popoverElementTitle, isMobile = _a.isMobile, popoverTitle = _a.popoverTitle, countries = _a.countries, contactMail = _a.contactMail, appId = _a.appId, onSupportClick = _a.onSupportClick, marketplaceStore = _a.marketplaceStore, experiments = _a.experiments, t = _a.t, madeByWix = _a.madeByWix;
    var shouldShowMobileModal = experiments.enabled('specs.marketplace.otherCountriesButtons');
    var footerTwo = madeByWix
        ? t('solution.page.tagsBoxAvailabilityPopoverFooter2-wix')
        : t('solution.page.tagsBoxAvailabilityPopoverFooter2');
    var openOtherCountriesModal = function () {
        marketplaceStore.openModal(ModalNames.OTHER_COUNTRIES_MODAL, {
            subtitle: "" + popoverTitle,
            // @ts-ignore
            closeModal: function () { return marketplaceStore.closeAllModals(); },
            countries: countries,
            footerTwo: "" + footerTwo,
            onSupportClick: function () { return onSupportClick(); },
        });
    };
    return isMobile && shouldShowMobileModal ? (React.createElement(TextButton, { onClick: openOtherCountriesModal }, popoverElementTitle)) :
        React.createElement(CountriesPopover, { popoverTitle: popoverTitle, popoverElementTitle: popoverElementTitle, countries: countries, popoverFooter1: t("solution.page.tagsBoxAvailabilityPopoverFooter1"), popoverFooter2: footerTwo, contactMail: contactMail, appId: appId, onSupportClick: onSupportClick });
});
//# sourceMappingURL=other-countries-options.js.map